export const DESCRIPTION_VARIABLES = ['supplier_name', 'invoice_number', 'transaction_date', 'existing_description', 'cost_type', 'cost_type_label', 'custom_text'];
export const DEFAULT_DESCRIPTION_TEMPLATE = {parts: [{type: 'existing_description'}]};

/** Mirror the API contract; legacy strings are validated by the existing path. */
export const validDescriptionTemplate = value => Array.isArray(value?.parts) && value.parts.length > 0 && value.parts.length <= 40 && value.parts.every(part =>
    part && (['text', 'custom_text'].includes(part.type) ? typeof part.text === 'string' && part.text.length > 0 && part.text.length <= 2000 && !/[\x00-\x1f]/.test(part.text) : DESCRIPTION_VARIABLES.includes(part.type)));

/** Preserve old ordering and the client's invoice label when explicitly converting. */
export function legacyDescriptionTemplate(action, language) {
    const parts = [];
    const appendText = text => {
        if (!text) return;
        if (parts.at(-1)?.type === 'text') parts[parts.length - 1].text += text;
        else parts.push({type: 'text', text});
    };
    appendText(String(action.value || '').trim());
    if (action.include_supplier_name) {
        if (parts.length) appendText(' ');
        parts.push({type: 'supplier_name'});
    }
    if (action.include_invoice_number) {
        const label = ['fr', 'french', 'français'].includes(language) ? 'Facture' : 'Invoice Number';
        appendText(`${parts.length ? ' ' : ''}${label} `);
        parts.push({type: 'invoice_number'});
    }
    return {parts};
}

/** Display the saved order or a fictional example without accessing customer data. */
export function descriptionTemplateLabel(value, read, example = false) {
    const examples = {supplier_name: 'Acme', invoice_number: 'INV-123', transaction_date: '2026-10-19', existing_description: 'Taxi', cost_type: 'TR', cost_type_label: 'Transport'};
    return (value?.parts || []).map(part => ['text', 'custom_text'].includes(part.type) ? part.text : example ? examples[part.type] : `{${read(`rule.description_${part.type}`)}}`).join('');
}

/** Turn legacy outer literals into editable custom-text chips; retain separators. */
export function descriptionTemplateSlots(value) {
    const variables = [];
    const texts = [''];
    for (const part of value?.parts || []) {
        if (part.type === 'text') texts[texts.length - 1] += part.text || '';
        else {
            variables.push(part);
            texts.push('');
        }
    }
    if (texts[0]) {
        variables.unshift({type: 'custom_text', text: texts[0]});
        texts[0] = '';
        texts.unshift('');
    }
    if (texts.at(-1)) {
        variables.push({type: 'custom_text', text: texts.at(-1)});
        texts[texts.length - 1] = '';
        texts.push('');
    }
    return {variables, texts};
}

/** Persist separators as literal parts, matching the invoice-number template format. */
export function descriptionTemplateFromSlots(variables, texts) {
    const parts = [];
    variables.forEach((part, index) => {
        if (texts[index]) parts.push({type: 'text', text: texts[index]});
        parts.push(part);
    });
    if (texts[variables.length]) parts.push({type: 'text', text: texts[variables.length]});
    return {parts};
}
